import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import TopBar from '../components/TopBar'
import Footer from '../components/Footer'
import './WWO.css'


import I from '../assets/111.svg'
import Pic1 from '../assets/WWO1.webp'
import Pic2 from '../assets/WWO2.webp'

import { motion as m } from "framer-motion";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useTranslation } from 'react-i18next'

gsap.registerPlugin(useGSAP);

const WWO = () => {
    
  const { i18n } = useTranslation();
  const { t } = useTranslation();

  const addHtml1 = t('WWO5');
  const addHtml2 = t('WWO6');
    //media query
    const [deviceWidth, setDeviceWidth] = useState(window.screen.width);

    useEffect(() => {
        const handleResize = () => {
            setDeviceWidth(window.screen.width);
        };
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    }, []);

    const location = useLocation(); // Hook to get location object
    const [re, setRe] = useState(location.state?.re ?? false);
    const handleChange1 = () => {
        setRe(false);
    }
    const handleChange2 = () => {
        setRe(true);
    }

    //landing

    const containerRef = useRef(null);
    gsap.registerPlugin(ScrollTrigger);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        // Wait for next paint to ensure DOM is updated
        requestAnimationFrame(() => {
            ScrollTrigger.refresh();

            const elements = container.querySelectorAll('.WWO-content-text');
            elements.forEach(element => {
                gsap.fromTo(element,
                    { opacity: 0, y: 50 },
                    {
                        opacity: 1,
                        y: 0,
                        duration: 0.8,
                        ease: "sine.out",
                        scrollTrigger: {
                            trigger: element,
                            start: "top 100%",
                            toggleActions: "play none none none",
                            onEnter: () => { element.classList.add('animated'); }
                        }
                    }
                );
            });

            const elements2 = container.querySelectorAll('.WWO-content-img');
            elements2.forEach(element => {
                gsap.fromTo(element,
                    { opacity: 0, },
                    {
                        opacity: 1,
                        duration: 0.8,
                        ease: "power1.in",
                        scrollTrigger: {
                            trigger: element,
                            start: "top 100%",
                            toggleActions: "play none none none",
                            onEnter: () => { element.classList.add('animated'); }
                        }
                    }
                );
            });
        });

        // Cleanup all triggers on component unmount or before updating
        return () => ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    }, [re]); // Depend on isActive or similar prop/state to rerun effect

    return (
        <m.div className="WWO"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: .25 }}
        >
            {/* <TopBar /> */}
            <div style={{ backgroundImage: `url(${I})` }} className="WWO-top">
                <div className="WWO-top-header">{t('WWO1')}</div>
                <div className="WWO-top-text">{t('WWO2')}</div>
            </div>
            <div className="WWO-menu">
                <div style={{ borderBottom: re ? 'none' : '2px solid #000' }} onClick={handleChange1} className="WWO-menu-option">
                    <div style={{ color: re ? '#A2A2A2' : '#000' }} className="WWO-menu-option-text">{t('WWO3')}</div>
                </div>
                <div style={{ borderBottom: re ? '2px solid #000' : 'none' }} onClick={handleChange2} className="WWO-menu-option">
                    <div style={{ color: re ? '#000' : '#A2A2A2' }} className="WWO-menu-option-text">{t('WWO4')}</div>
                </div>
            </div><div className="WWO-content" ref={containerRef}>
                {!re && <>
                    {deviceWidth < 1024 && <img loading="lazy" decoding="async" alt="" className="WWO-content-img" src={Pic1} />}
                    <div className="WWO-content-text" dangerouslySetInnerHTML={{ __html: addHtml1 }}></div>
                    {deviceWidth > 1023 && <img loading="lazy" decoding="async" alt="" className="WWO-content-img" src={Pic1} />}
                </>}
                {re && <>
                    {deviceWidth < 1024 && <img loading="lazy" decoding="async" alt="" className="WWO-content-img" src={Pic2} />}
                    <div className="WWO-content-text" dangerouslySetInnerHTML={{ __html: addHtml2 }}></div>
                    {deviceWidth > 1023 && <img loading="lazy" decoding="async" alt="" className="WWO-content-img" src={Pic2} />}
                </>}</div>
            <Footer />
        </m.div>
    )
}

export default WWO